import { render, staticRenderFns } from "./DeptMngPopup.vue?vue&type=template&id=5e6b2524&"
import script from "./DeptMngPopup.vue?vue&type=script&lang=js&"
export * from "./DeptMngPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports